import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { Guid } from 'src/utility/guid';
import { ApiConfig } from './api-config/api-config';
import { AS_IS } from './http-interceptor/http-interceptor.service';

const UNKNOWN = 'unknown';

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  constructor(
    private readonly http: HttpClient,
  ) {
    ApiConfig.updateClientHeaders(this);
  }

  private readonly domParser = new DOMParser();
  fetchLatestVersion(): Observable<string> {
    const href = window.location.href.split('#')[0];
    // fetch the latest index.html; add a unique query param to avoid cached responses
    const url = `${href}index.html?unique=${Guid.newGuid()}`;
    const headers = new HttpHeaders().set(AS_IS, 'true');
    return this.http.get(url, { headers: headers, responseType: 'text' })
      .pipe(catchError(_err => of(UNKNOWN)))
      .pipe(map(html => {
        const doc = this.domParser.parseFromString(html, 'text/html');
        return this.parseVersion(doc, UNKNOWN);
      })
    );
  }

  detectAppVersion(defaultValue: string = UNKNOWN): string {
    return this.parseVersion(document, defaultValue);
  }

  private parseVersion(doc: Document, defaultValue: string): string {
    if (!doc?.body) return defaultValue;
    // look for the app script tags that look like this:
    // <script src="/1.47.0.2012-dev/runtime.3e97f39af47036e8.js" type="module"></script>
    // the first path segment of the script src is the app version.
    const parts = doc?.body?.querySelectorAll("script[type='module']")[0]?.getAttribute('src')?.split('/')?.filter(p => !!p);
    if ((parts?.length ?? 1) <= 1) return defaultValue;
    return parts[0];
  }
}
